<template>
  <div>
    <a-upload
      :accept="accept"
      :multiple="limit > 1"
      :file-list="fileList"
      :before-upload="beforeFileUpload"
      :customRequest="handleFileUpload"
      :disabled="disabled || fileList.length >= limit"
      :showUploadList="false"
    >
      <a-button class="spaceLeft" style="color: #1990ff">
        <svg class="icon img-icon" aria-hidden="true">
          <use xlink:href="#gold-icon-shangchuan"></use></svg
        >上传文件
      </a-button>
    </a-upload>
    <div class="table-common common tableData" v-if="tableData.length > 0">
      <a-table
        :scroll="{x: '100%', y: '170px'}"
        :loading="tableLoading"
        size="middle"
        :row-key="(record,index) => record.id+'_'+index"
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        bordered
        :locale="{ emptyText: '暂无数据' }"
      >

        <template slot="createTime" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd HH:MM:SS") }}
        </template>
        <template slot="status" slot-scope="text,record">
          <img v-if="record.status === 'done'" width="18" height="18" src="../../../assets/images/icon-img/file_done.png"/>
          <img v-if="record.status === 'uploading'" width="18" height="18" src="../../../assets/images/icon-img/file_done.png"/>
          <img v-if="record.status === 'wait' || record.status === ''" width="18" height="18" src="../../../assets/images/icon-img/file_done.png"/>
          {{ getStatusRecod(record)}}
        </template>
        <template slot="oper" slot-scope="text, record, index">
          <span
            class="text-color-red pointer"
            @click="delFun(record, index)"
          >删除</span
          >
<!--          <a @click="downloadFile(record)">下载</a>-->
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { fileDeletAPI, fileSaveAPI, fileQueryAPI} from "@/api/file.js";
export default {
  name: "fileUpload",
  props: {
    accept: {
      type: String,
      required: false,
      default: function () {
        return ".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF,.zip,.ZIP,.rar,.RAR,.doc,.docx,.xls,.xlsx,.ppt,.pptx";
      },
    },
    url: {
      type: String,
      required: false,
      default() {
        return "/gb-bigtree-file/fileUpload";
      },
    },
    // 可传入接口需要的参数
    paramObj: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    name: {
      type: String,
      required: true,
    },
    limit: {
      type: [String, Number],
      required: false,
      default: function () {
        return 1;
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    }
  },
  data() {
    return {
      fileList: [],
      paramObjSelf: this.utils.deepClone(this.paramObj),
      uploadFlag: true,
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: "文件名称",
          dataIndex: "fileNm",
          width:"60%"
        },
        // {
        //   title: "上传人",
        //   dataIndex: "createUser"
        // },
        // {
        //   title: "上传日期",
        //   dataIndex: "createTime",
        //   scopedSlots: { customRender: "createTime" }
        // },
        {
          title: "上传结果",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
          width:"20%"
        },
        {
          title: "操作",
          dataIndex: "oper",
          scopedSlots: { customRender: "oper" },
          width:"20%"
        }
      ]
    };
  },
  methods: {
    initData() {
      this.tableData = [];
      this.paramObjSelf = this.utils.deepClone(this.paramObj)
    },
    beforeFileUpload(file) {
      const isLt4M = file.size / 1024 / 1024 <= 100
      if (!isLt4M) {
        this.$message.error('上传文件不能大于100M')
        return false
      }
      if (file.name && file.name.indexOf(".") > -1) {
        let d_name = file.name.substring(file.name.lastIndexOf(".") + 1);
        if (this.accept.indexOf(d_name) > -1) {
          if ((this.fileList.length+1)  > this.limit || (this.tableData.length+1) > this.limit) {
            this.$message.warning(`选择文件不能超过${this.limit}个`)
            return false
          }
          let inItem = this.tableData.find(i => i.fileNm == file.name);
          if (inItem) {
            this.$message.warn("附件已在列表中，不可重复提交");
            return false;
          }
          this.tableData = [...this.tableData, {
            "fileNm":file.name,
            "uid":file.uid,
            "id":'',
            "fileId":'',
            "status":"wait"
          }];
        } else {
          this.$message.error("请上传" + this.accept + "格式的文件");
          return false;
        }
      } else {
        this.$message.error("请上传" + this.accept + "格式的文件");
        return false;
      }
    },
    handleFileUpload(fileInfo) {
      this.tableData.forEach(item =>{
          if(item.uid === fileInfo.file.uid){
            item.status = 'uploading'
            return true
          }
      });

      const formData = new FormData();
      formData.append(this.name, fileInfo.file)
      for (let key in this.paramObjSelf) {
        formData.append(key, this.paramObjSelf[key])
      }

      this.axios({
        url: this.url,
        data: formData,
        isTransform: false,
      })
        .then((res) => {})
        .catch((data) => {
          if (data[0]) {
            let fileData ={
              name: fileInfo.file.name,
              size: fileInfo.file.size,
              uid: fileInfo.file.uid,
              fileExpdNm: data[0].contentType,
              fileRte: JSON.parse(data[0].savePath).file,
              tblBlId: this.paramObjSelf.tblBlId,
              fileTpCd: this.paramObjSelf.fileTpCd,
              fileSubTpCd: this.paramObjSelf.fileSubTpCd,
            }
            this.fileSave(fileData)
          }
        });
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: data.tblBlId,
        mdlId: "10068",
        fileTpCd: "5",
        fileSubTpCd: 0
      };
      fileSaveAPI(param)
        .then(res => {
          this.$emit("uploadOk", data, this.paramObjSelf);

          this.tableData.forEach(item =>{
            if(item.uid === data.uid){
              item.status = 'done'
              item.id = res.data.id
              item.fileId = res.data.fileId
              item.tblBlId = res.data.tblBlId
              return true
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    delFun(record, index) {
      const self = this;
      this.$confirm({
        title: "删除",
        content: "您正在进行删除操作，是否确认？",
        onOk() {
          if(record.id === ''){
            self.tableData.splice(index, 1);
          }else{
            fileDeletAPI({
              id: record.id,
              tblBlId: record.tblBlId,
              fileId: record.fileId
            }).then(res => {
              self.$message.success("删除成功");
              self.tableData.splice(index, 1);
              // self.$emit("save");
            });
          }
        },
        onCancel() {}
      });
    },
    getStatusRecod(recod) {
      if(recod.status === 'done') {
        return '已完成'
      } else if(recod.status === 'uploading') {
        return '上传中'
      } else {
        return '待上传'
      }
    },
    downloadFile(item) {
      const DOWNLOAD_PREFIX = "/gb-bigtree-file/download/fileDownload/install";
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        "_blank"
      );
    }
  },
};
</script>
<style scoped lang="less">
.ant-upload.ant-upload-disabled .ant-btn {
  cursor: no-drop;
  background: #f5f5f5;
}
.img-icon {
  font-size: 18px;
  cursor: pointer;
}
.tableData {
  position: relative;
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/qxkl-file-upload/index.vue